"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var warning_1 = __importDefault(require("warning"));

var clsx_1 = __importDefault(require("clsx"));

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var util_1 = require("./styles/util");

var IconButton = function IconButton(_a) {
  var className = _a.className,
      margin = _a.margin,
      props = __rest(_a, ["className", "margin"]);

  warning_1.default(props['aria-label'], 'Unifi: IconButton requires an aria-label prop. For a working, accessible example, see https://unifi.nelnet.io/components/controls/buttons#icon-buttons');
  var classes = clsx_1.default(className, util_1.createMarginClassNames({
    margin: margin
  }));
  return React.createElement(IconButton_1.default, Object.assign({
    disableRipple: true
  }, props, {
    className: classes
  }));
};

exports.default = IconButton;